module.exports = __webpack_public_path__ + "static/img/pin_ambulancia.c079ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pin_ambulancia.png
// module id = N+eP
// module chunks = 4